import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    sendToMyself: 'Send myself a test email',
  },
  fr: {
    sendToMyself: 'M’envoyer un e-mail test',
  },
} as const);
